/**
 * Генерация правильных ссылок для промокодов
 */

const BASE_URL = 'https://ggstand.live/m/ggturbo'

/**
 * Типы промокодов и соответствующие им параметры URL
 */
export const PromoUrlType = {
    // Бонусные промокоды (bonus_promo_code)
    BONUS: 'bonus', // Промокод (общий)
    CASE: 'bonus', // Промокод на кейс
    SKIN: 'bonus', // Промокод на скин
    XP: 'bonus', // Промокод на XP
    BALANCE: 'bonus', // Промокод на баланс

    // Депозит промокоды (promo_code)
    DEPOSIT: 'deposit', // Промокод на депозит
    DEPOSIT_CASE: 'deposit', // Бесплатный кейс при депозите

    // Барабан промокоды (wheel_code)
    WHEEL: 'wheel', // Промокод на барабан
}

/**
 * Получить правильную ссылку с промокодом
 * @param {string} promoCode - Промокод
 * @param {string} type - Тип промокода (из PromoUrlType)
 * @returns {string} - URL с промокодом
 */
export const getPromoUrl = (promoCode, type = PromoUrlType.BONUS) => {
    if (!promoCode) {
        return 'https://ggstand.live'
    }

    let paramName
    let utmContent

    switch (type) {
        case PromoUrlType.DEPOSIT:
        case PromoUrlType.DEPOSIT_CASE:
            paramName = 'promo_code'
            utmContent = 'promodep'
            break

        case PromoUrlType.WHEEL:
            paramName = 'wheel_code'
            utmContent = 'promowheel'
            break

        case PromoUrlType.BONUS:
        case PromoUrlType.CASE:
        case PromoUrlType.SKIN:
        case PromoUrlType.XP:
        case PromoUrlType.BALANCE:
        default:
            paramName = 'bonus_promo_code'
            utmContent = 'promobonus'
            break
    }

    const encodedPromo = encodeURIComponent(promoCode)
    return `${BASE_URL}?${paramName}=${encodedPromo}&utm_source=telegram_bot&utm_medium=performance&utm_campaign=ggturbo&utm_content=${utmContent}`
}

/**
 * Получить тип промокода по типу приза из AdventRewardType
 * @param {string} rewardType - Тип награды (PROMO_CASE, PROMO_DEPOSIT, и т.д.)
 * @returns {string} - Тип для getPromoUrl
 */
export const getPromoTypeFromRewardType = (rewardType) => {
    switch (rewardType) {
        case 'PROMO_CASE':
            return PromoUrlType.CASE

        case 'PROMO_SKIN':
            return PromoUrlType.SKIN

        case 'PROMO_XP':
            return PromoUrlType.XP

        case 'PROMO_BALANCE':
            return PromoUrlType.BALANCE

        case 'PROMO_DEPOSIT':
            return PromoUrlType.DEPOSIT

        case 'DEPOSIT_FREE_CASE':
            return PromoUrlType.DEPOSIT_CASE

        case 'PROMO_WHEEL':
            return PromoUrlType.WHEEL

        default:
            return PromoUrlType.BONUS
    }
}

/**
 * Получить тип промокода по типу приза (frontend константы)
 * @param {string} prizeType - Тип приза (case, deposit-code, и т.д.)
 * @returns {string} - Тип для getPromoUrl
 */
export const getPromoTypeFromPrizeType = (prizeType) => {
    switch (prizeType) {
        case 'case':
            return PromoUrlType.CASE

        case 'skin-code':
            return PromoUrlType.SKIN

        case 'xp-code':
            return PromoUrlType.XP

        case 'balance-code':
            return PromoUrlType.BALANCE

        case 'deposit-code':
            return PromoUrlType.DEPOSIT

        case 'deposit-free-case':
            return PromoUrlType.DEPOSIT_CASE

        case 'wheel-code':
            return PromoUrlType.WHEEL

        case 'gift':
            return PromoUrlType.BONUS

        default:
            return PromoUrlType.BONUS
    }
}
